/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export var TSDataType;
(function (TSDataType) {
    TSDataType["TMY"] = "TMY";
    TSDataType["TimeSeries"] = "TimeSeries";
})(TSDataType || (TSDataType = {}));
export var Granularity;
(function (Granularity) {
    Granularity["1h"] = "1h";
    Granularity["30min"] = "30min";
    Granularity["15min"] = "15min";
    Granularity["10min"] = "10min";
    Granularity["5min"] = "5min";
})(Granularity || (Granularity = {}));
export const granularityMap = {
    '1h': 'Hourly',
    '30min': '30min',
    '15min': '15min',
    '10min': '10min',
    '5min': '5min',
};
export const granularityFreqMap = {
    '1h': 1,
    '30min': 2,
    '15min': 4,
    '5min': 12,
    '1min': 60,
    '30S': 120,
};
//# sourceMappingURL=energy.js.map